import Cookies from 'js-cookie'

// const TOKEN_KEY = 'unique_code'

export const setToken = (TOKEN_KEY,token,time) => {
  Cookies.set(TOKEN_KEY, token, {
    expires: time //设置存储天数
  })
}

export const getToken = (TOKEN_KEY_TWO) => {
  const token = Cookies.get(TOKEN_KEY_TWO)
  if (token) return token
  else return false
}

export const getDay = (num, str) => {
  var today = new Date()
  var nowTime = today.getTime()
  var ms = 24 * 3600 * 1000 * num
  today.setTime(parseInt(nowTime + ms))
  var oYear = today.getFullYear()
  var oMoth = (today.getMonth() + 1).toString()
  if (oMoth.length <= 1) oMoth = '0' + oMoth
  var oDay = today.getDate().toString()
  if (oDay.length <= 1) oDay = '0' + oDay
  return oYear + str + oMoth + str + oDay
}



//////////////////
// WEBPACK FOOTER
// ./static/js/util.js
// module id = VqYF
// module chunks = 31